// Indian food-app style veg / non-veg dot: green square for veg, brown-red for non-veg.
// Sweet pickles are all veg — treat as veg.

export const VegDot = ({ isVeg, size = 12, className = "" }) => {
    const color = isVeg ? "#2f7a1a" : "#8B1A1A";
    return (
        <span
            className={`inline-flex items-center justify-center border ${className}`}
            style={{
                width: size,
                height: size,
                borderColor: color,
            }}
            aria-label={isVeg ? "Vegetarian" : "Non-vegetarian"}
            data-testid={isVeg ? "veg-dot" : "nonveg-dot"}
        >
            <span
                style={{
                    width: size * 0.42,
                    height: size * 0.42,
                    background: color,
                    borderRadius: isVeg ? 1 : "50%",
                    display: "block",
                }}
            />
        </span>
    );
};
